module.exports = {"googleMapsApiKey":"AIzaSyB6-fVLJVYP6adV_9LdMUSjQCK70ZUC0tA","apiUrl":"https://api.breeze.dating/v1"};